import { Injectable } from '@angular/core';
import { EnvConfigService } from 'ngx-mat-esign360/lib/core/services/env-config.service';
import { EMPTY, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  readonly VERSION_LS_KEY = 'version';

  constructor(private envConfig: EnvConfigService) {}

  getCurrentVersion(): string {
    return localStorage.getItem(this.VERSION_LS_KEY) || 'definitely not a random hash';
  }

  updateVersion(): void {
    localStorage.setItem(this.VERSION_LS_KEY, this.envConfig.data.repohash);
  }

  checkVersion(versionChangedCallback: () => any): void {
    if (this.getCurrentVersion() !== this.envConfig.data.repohash) {
      versionChangedCallback();
      this.updateVersion();
    }
  }

  checkVersionAsync(versionChangedCallback: () => Observable<any>): Observable<any> {
    if (this.getCurrentVersion() !== this.envConfig.data.repohash) {
      return versionChangedCallback().pipe(
        tap(() => {
          this.updateVersion();
        })
      );
    }
    return EMPTY;
  }

  printVersion(): void {
    console.log(
      `%cVersion hash: %c${this.envConfig.data.repohash}`,
      'padding: 10px 0; color: #3F51B5',
      'font-weight: bold;'
    );
  }
}
